import { LEGEND } from "../../utils/attendance";

/** Colour legend shown under the muster grid and month calendars. */
export default function AttendanceLegend({ exclude = [] }) {
  return (
    <div className="row gap-md" style={{ flexWrap: "wrap", padding: "8px 2px" }}>
      {LEGEND.filter((l) => !exclude.includes(l.status)).map((l) => (
        <span key={l.status} className="row gap-sm text-xs t-muted" style={{ alignItems: "center" }}>
          {l.marker ? (
            <span style={{ color: l.color, fontWeight: 700, fontSize: 12, lineHeight: 1 }}>{l.code}</span>
          ) : (
            <span
              style={{
                width: 12,
                height: 12,
                borderRadius: 3,
                background: l.soft,
                border: `1.5px solid ${l.color}`,
                display: "inline-block",
              }}
            />
          )}
          {l.label}
        </span>
      ))}
    </div>
  );
}
